import 'colcade';
import _ from 'lodash';
import Mark from 'mark.js';

const History = window.history;
const Query = require('query-string');

const $ = window.jQuery;
const suggest_url =
    'https://search-api.swiftype.com/api/v1/public/engines/suggest.json';
const search_url =
    'https://search-api.swiftype.com/api/v1/public/engines/search.json';
const engine_key = '2_pRxPU2QYeuUQ3PN3SU';

$(() => {
    let query = Query.parse(window.location.search);
    const $body = $('html,body');

    if (!$body.hasClass('search')) {
        return;
    }

    const $results = $('#search-results');

    $results.colcade({
        columns: '.search__col',
        items: '.search-result',
    });

    const $search = $('#search-main');
    const $search_mobile = $('#search-mobile');
    const $autocomplete = $('#search-autocomplete-results');
    const $barrier = $('#search-autocomplete-barrier');
    const $filter = $('#select-type');
    const $search_load = $('.search--load');
    const $num_showing = $('#search-num-showing');
    const loading = `<div class="aam__loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;
    const api_url = $results.attr('data-api-url');
    const per_page = $results.attr('data-per-page');

    let searching = false;

    const label_key = {
        'blog-post': 'Blog Posts',
        collection: 'Collections',
        event: 'Events',
        exhibition: 'Exhibitions',
        page: 'Pages',
        press: 'Press Items',
        resource: 'Resources',
        tour: 'Tours',
    };

    $search.on(
        'keyup',
        _.debounce(function(e) {
            if (e.keyCode === 13) {
                return;
            }

            const q = $search.val().trim();

            if (!searching) {
                if (!q) {
                    $autocomplete.html('');
                    $body.removeClass('--resources-search-active');
                    return;
                }

                $body.addClass('--resources-search-active');
                searching = true;
                $autocomplete.html(loading);

                setTimeout(() => {
                    $.ajax({
                        url: `${api_url}?s=${q}`,
                        type: 'GET',
                        contentType: 'application/json; charset=UTF-8',
                        headers: { 'Content-Type': 'application/json' },
                        // data: { engine_key, q },
                        complete: () => {
                            searching = false;
                        },
                    }).done(res => {
                        const { hits } = res;
                        let results_html = ``;

                        let sorted = {};

                        hits.forEach(hit => {
                            if (!sorted[hit.doc_type]) {
                                sorted[hit.doc_type] = [hit];
                            } else {
                                sorted[hit.doc_type].push(hit);
                            }
                        });

                        _.each(sorted, (results, type) => {
                            if (results.length) {
                                let record_type_html = `<ul class="aam-autocomplete -padded--h">`;
                                record_type_html += `<li class="aam-autocomplete__title">${type +
                                    (type === 'Press' ? '' : 's')}</li>`;

                                _.each(results, result => {
                                    record_type_html += `<li class="aam-autocomplete__item">`;
                                    record_type_html += `<a class="aam-autocomplete__item-link" href="${
                                        result.url
                                    }">`;
                                    record_type_html += `${result.title}</a>`;
                                    record_type_html += `</li>`;
                                });

                                record_type_html += `</ul>`;
                                results_html += record_type_html;
                            }
                        });

                        const button_text = `Show all results`;
                        results_html += `<a href="${window.AAM_MAIN_SITE ||
                            ''}/?s=${q}" class="aam-autocomplete__all button button--gold button--lg">${button_text}</a>`;

                        $autocomplete.html(results_html);
                        const instance = new Mark(
                            'a.aam-autocomplete__item-link',
                        );
                        instance.mark(q);
                    });
                }, 300);
            }
        }, 400),
    );

    $barrier.on('click', () => {
        $autocomplete.html('');
        $body.removeClass('--resources-search-active');
    });

    $filter.on('change', function(e) {
        delete query['page'];
        const val = $(this).val();
        if (val) {
            query[$(this).attr('name')] = val;
        } else {
            delete query[$(this).attr('name')];
        }
        History.pushState(null, null, `?${Query.stringify(query)}`);
        $results.trigger('query_change');
        window.location.reload();
    });

    const $load_more = $search_load.find('.card-feed__more-button').first();

    $load_more.on('click', () => {
        const next_page = parseInt($results.attr('data-page')) + 1;
        $results.attr('data-page', next_page);
        $search_load.addClass('card-feed--loading');

        let data = {
            hitsPerPage: per_page,
            page: next_page,
        };

        if (query.s) {
            data.s = query.s;
        }

        if (query.type) {
            data.post_type = query.type;
        }

        const qs = Query.stringify(data);

        $.ajax({
            url: `${api_url}/?${qs}`,
            type: 'GET',
            contentType: 'application/json; charset=UTF-8',
            headers: { 'Content-Type': 'application/json' },
        }).done(res => {
            const more_pages = res.page !== res.nbPages - 1;
            const showing =
                res.hitsPerPage * (res.page + 1) > res.nbHits
                    ? res.nbHits
                    : res.hitsPerPage * (res.page + 1);

            $num_showing.html(showing);

            if (
                !more_pages &&
                !$search_load.hasClass('search--load--collapse')
            ) {
                $search_load.addClass('search--load--collapse');
            }

            let results = [];

            res.hits.forEach(hit => {
                results.push(`
                    <article class="search-result animated fadeInUp">
                        <a class="search-result__inner" href="${hit.url}">
                            <div class="search-result__type">${
                                hit.doc_type
                            }</div>
                            <div class="search-result__title">${hit.title}</div>
                            <div class="search-result__excerpt">${
                                hit.excerpt
                            }</div>
                        </a>
                    </article>
                `);
            });

            let results_nodes = [];

            _.each(results, result => {
                $search_mobile.append(result);
                let div = document.createElement('div');
                div.classList.add('animated', 'fadeInUp');
                div.innerHTML = result;
                results_nodes.push(div);
            });

            _.each(results_nodes, node => {
                $results.colcade('append', node);
            });

            $search_load.removeClass('card-feed--loading');
        });
    });

    // $load_more.on('click', () => {
    //     const next_page = parseInt($results.attr('data-page')) + 1;
    //     $results.attr('data-page', next_page);

    //     $search_load.addClass('card-feed--loading');

    //     let data = {
    //         engine_key,
    //         per_page,
    //         page: next_page,
    //     };

    //     if (query.s) {
    //         data.q = query.s;
    //     }

    //     if (query.type) {
    //         data.document_types = [query.type];
    //     }

    //     $.ajax({
    //         url: search_url,
    //         type: 'GET',
    //         contentType: 'application/json; charset=UTF-8',
    //         headers: { 'Content-Type': 'application/json' },
    //         data,
    //     }).done(res => {
    //         let more_pages = false;
    //         let showing = parseInt($num_showing.text());

    //         $num_showing.html(res.record_count + showing);

    //         _.each(res.info, (info, doc_type) => {
    //             if (!more_pages && info.num_pages > info.current_page) {
    //                 more_pages = true;
    //             }
    //         });

    //         if (!res.record_count || !more_pages) {
    // if (!$search_load.hasClass('search--load--collapse')) {
    //     $search_load.addClass('search--load--collapse');
    // }
    //         }

    //         let results = [];

    //         _.each(res.records, (records, record_type) => {
    //             _.each(records, record => {
    //                 const { title, url, post_id, external_id, score } = record;
    //                 const doc_type = label_key[record_type];
    //                 const add_class = 'animated fadeInUp';
    //                 results.push({
    //                     title,
    //                     url,
    //                     post_id,
    //                     external_id,
    //                     score,
    //                     doc_type,
    //                     add_class,
    //                 });
    //             });
    //         });

    //         $.ajax({
    //             url: api_url,
    //             type: 'POST',
    //             data: { results },
    //         }).done(rendered => {
    // let results_nodes = [];

    // _.each(rendered, result => {
    //     $search_mobile.append(result);
    //     let div = document.createElement('div');
    //     div.classList.add('animated', 'fadeInUp');
    //     div.innerHTML = result;
    //     results_nodes.push(div);
    // });

    // _.each(results_nodes, node => {
    //     $results.colcade('append', node);
    // });

    // $search_load.removeClass('card-feed--loading');
    //         });
    //     });
    // });
});
